import { AnyAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { AppConfigurationService } from '../service';
import {
	getAppConfig,
	getAppConfigFailure,
	getAppConfigSuccess,
	updateAppPlatformVersionsConfig,
	updateAppPlatformVersionsConfigFailure,
	updateAppPlatformVersionsConfigSuccess,
	updateLessonTypeConfig,
	updateLessonTypeConfigFailure,
	updateLessonTypeConfigSuccess,
	updateNumberCombinationConfig,
	updateNumberCombinationConfigFailure,
	updateNumberCombinationConfigSuccess,
	updatePronounConfig,
	updatePronounConfigFailure,
	updatePronounConfigSuccess,
	updateRegionConfig,
	updateRegionConfigFailure,
	updateRegionConfigSuccess,
	updateTimeCombinationConfig,
	updateTimeCombinationConfigFailure,
	updateTimeCombinationConfigSuccess,
} from './slice';

function* getAppConfigHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new AppConfigurationService(
			globalApplicationContext,
		);
		const data = yield regionsConfigurationService.getAppConfig();
		yield put(getAppConfigSuccess(data));
	} catch (e) {
		yield put(getAppConfigFailure({}));
	}
}

function* updateLessonTypeConfigHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new AppConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateLessonTypeConfig(action.payload);
		yield put(updateLessonTypeConfigSuccess(action.payload));
		toast('Lesson type config updated successfully.', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateLessonTypeConfigFailure({}));
	}
}

function* updatePronounConfigHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new AppConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updatePronounConfig(action.payload);
		yield put(updatePronounConfigSuccess(action.payload));
		toast('Pronoun image updated successfully.', {
			type: 'success',
		});
	} catch (e) {
		yield put(updatePronounConfigFailure({}));
	}
}

function* updateRegionConfigHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new AppConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateRegionConfig(action.payload);
		yield put(updateRegionConfigSuccess(action.payload));
		toast('Region config updated successfully.', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateRegionConfigFailure({}));
	}
}

function* updateAppPlatformVersionsConfigHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new AppConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateAppPlatformVersionsConfig(
			action.payload,
		);
		yield put(updateAppPlatformVersionsConfigSuccess(action.payload));
		toast('App versions updated successfully.', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateAppPlatformVersionsConfigFailure({}));
	}
}

function* updateNumberCombinationConfigHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new AppConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateNumberCombinationConfig(
			action.payload,
		);
		yield put(updateNumberCombinationConfigSuccess(action.payload));
		toast('Number combination config updated successfully.', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateNumberCombinationConfigFailure({}));
	}
}

function* updateTimeCombinationConfigHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const regionsConfigurationService = new AppConfigurationService(
			globalApplicationContext,
		);
		yield regionsConfigurationService.updateTimeCombinationConfig(
			action.payload,
		);
		yield put(updateTimeCombinationConfigSuccess(action.payload));
		toast('Time config updated successfully.', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateTimeCombinationConfigFailure({}));
	}
}

export function* appConfigurationSaga(): Generator<any, any, any> {
	yield all([
		takeEvery(getAppConfig, getAppConfigHandler),
		takeEvery(updateLessonTypeConfig, updateLessonTypeConfigHandler),
		takeEvery(updatePronounConfig, updatePronounConfigHandler),
		takeEvery(updateRegionConfig, updateRegionConfigHandler),
		takeEvery(
			updateAppPlatformVersionsConfig,
			updateAppPlatformVersionsConfigHandler,
		),
		takeEvery(
			updateNumberCombinationConfig,
			updateNumberCombinationConfigHandler,
		),
		takeEvery(updateTimeCombinationConfig, updateTimeCombinationConfigHandler),
	]);
}
